import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PopupWrapper from "../Common/PopupWrapper";
import i18next from "i18next";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";

class ScheduleVacationForm extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            //isDataReady: false,
            rowIndex: null
        }
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        //console.log(`this.props.rowKey: ${JSON.stringify(this.props.rowKey)}`);
        let rowIndex;
        if (this.props.addMode) {
            await this.props.dispatch(this.props.dataItem.beginAdd());
            rowIndex = this.props.dataItem.rowInEditIndex;
        } else {
            rowIndex = this.props.dataItem.getRowIndex(this.props.rowKey);
            await this.props.dispatch(this.props.dataItem.beginEdit(rowIndex));
        }
        this.setState({/*isDataReady: true, */rowIndex: rowIndex});
    }

    onSave = async (e) => {
        if (e) e.preventDefault();
        if (this.props.addMode) {
            await this.props.dispatch(this.props.dataItem.saveAdd(this.state.rowIndex));
        } else {
            await this.props.dispatch(this.props.dataItem.save(this.state.rowIndex));
        }
        if (!this.props.dataItem.isError) {
            this.props.hideEditor();
            this.props.refreshDataItem();
            /*
                        if(this.props.onClose){
                            this.props.onClose();
                        }
            */
        }
    }

    onCancel = async (e) => {
        if (e) e.preventDefault();
        if (this.props.addMode) {
            await this.props.dispatch(this.props.dataItem.cancelAdd());
        } else {
            await this.props.dispatch(this.props.dataItem.cancelEdit());
        }
        if (!this.props.dataItem.isError) {
            this.props.hideEditor();
            this.props.refreshDataItem();
            /*
                        if (this.props.onClose) {
                            this.props.onClose();
                        }
            */
        }
    }

    onDelete = async (e) => {
        if (e) e.preventDefault();
        try {
            await confirm(i18next.t("Schedule_Vacation_Form_1", {name: this.props.title.toLowerCase()}));
            await this.props.dispatch(this.props.dataItem.deleteRow(this.state.rowIndex));
            this.props.hideEditor();
            this.props.refreshDataItem();
        } catch (e) {}
        /*
                if (this.props.onClose) {
                    this.props.onClose();
                }
        */
    }

    renderButtons = () => {
        return (<div className="modal-footer text-right">
            <div className="text-right">
                {/*
                <button className="btn btn-regular" onClick={this.onDelete}>{i18next.t('Delete')} </button>
                &nbsp;
*/}
                <button className="btn btn-regular -goahead ml1ex" onClick={this.onSave}>{i18next.t('Save')} </button>
                &nbsp;
                <button className="btn btn-regular" onClick={this.onCancel}>{i18next.t('Cancel')}</button>
            </div>
        </div>);
    }

    refreshDataItem = async () => {
        await this.props.dispatch(this.props.dataItem.refresh());
    }

    paramRender = (h) => {
        return (<div className="row">
            <div className="col-md-12">
                {h.fs.map((fi) => {
                    const fn = fi.Name;
                    return (<React.Fragment key={fn}>
                        <div className="row">
                            <div className="col-md-3 field-title">
                                {h.lbl(fn)}
                            </div>
                            <div className="col-md-9">
                                {h.ed(fn)}
                            </div>
                        </div>
                        <hr/>
                    </React.Fragment>)
                })}
            </div>
        </div>)
    }

    render() {
        //if(!this.state.isDataReady) return null;
        return (<PopupWrapper popupVisible={true}
                              title={i18next.t((this.props.addMode ? "Schedule_Vacation_Form_2" : "Edit"), {title: this.props.title})}
                              instructionId="ScheduleVacationForm"
                              staticTitle={i18next.t("Scheule_Vacation_Form_3")}
                              onClose={this.onCancel} renderButtons={this.renderButtons} maxWidthBody="500px">
            <div>
                <ComplexParam dataItem={this.props.dataItem} autoApplyParams={false} showSearchBar={false}
                              renderParams={this.paramRender}
                              rowIndex={this.state.rowIndex}
                              customFieldExMap={this.props.customFieldExMap}
                />
            </div>
        </PopupWrapper>)
    }
}

ScheduleVacationForm.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object,
    onClose: PropTypes.func,
    onDelete: PropTypes.func,
    title: PropTypes.string,
    readOnly: PropTypes.bool,
    addMode: PropTypes.bool.isRequired,
    rowKey: PropTypes.object,
};


ScheduleVacationForm.defaultProps = {
    readOnly: false
};

function mapStateToProps(state, ownProps) {
    return {}
}

export default connect(mapStateToProps)(ScheduleVacationForm)